import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { PHONE_COUNTRY_CODE } from 'constants/global';
import './styles.scss';

function Input(props) {
  const {
    label = '',
    value = '',
    onChange = () => {},
    type = 'text',
    name = '',
    required = false,
    className = '',
    autoComplete = '',
    placeholder = '',
    error = '',
    disabled = false,
    prefix: prefixParam = '',
    onBlur = null,
    ...rest
  } = props;

  const prefix = useMemo(() => {
    if (prefixParam || prefixParam === false) {
      return prefixParam;
    }
    return type === 'tel' ? PHONE_COUNTRY_CODE : '';
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefixParam, type]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (type === 'tel' && newValue && (!/^\d+$/.test(newValue) || newValue.length > 10)) {
      return;
    }
    onChange(newValue);
  };

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e);
    } else {
      const newValue = (e?.target?.value || '').trim();
      if (newValue !== value) {
        onChange(newValue);
      }
    }
  };

  return (
    <div className={`ui-input ${className}`}>
      {label && (
        <label htmlFor={name} className='mb-1'>
          {label}
          {required && '*'}
        </label>
      )}
      <div className={prefix ? 'prefix' : ''}>
        {prefix && <span>{prefix}</span>}
        <input
          id={name || undefined}
          required={required}
          value={value}
          onChange={handleChange}
          name={name}
          type={type}
          className={`form-control ${error ? 'is-invalid' : ''} ${label ? 'has-label' : ''}`}
          placeholder={placeholder ? `${placeholder}${required ? '*' : ''}` : ''}
          autoComplete={autoComplete}
          disabled={disabled}
          onBlur={handleBlur}
          {...rest}
        />
      </div>
      {error && (
        <div className='invalid-feedback'>
          {error}
        </div>
      )}
    </div>
  );
}

Input.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  autoComplete: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default Input;
